import { isNil } from 'lodash';
import { trackEvent } from 'shared/analytics';
import { LoginMode } from 'shared/api';
import type { User } from 'shared/api/users';
import { history } from 'shared/constants';
import { UserType } from 'shared/enums';
import { Events } from 'shared/enums/events';
import {
  ENFORCEMENT_MODAL_KEY,
  PASSWORD_ENFORCEMENT_MODAL_KEY,
} from 'src/auth';
import {
  LoginModeManager,
  OrgMetaManager,
  ProductivityFiltersManager,
  TokenManager,
  UserLocalDataManager,
} from './local-storage-managers';

export const logout = () => {
  trackEvent(Events.AnalyticsReset);

  TokenManager.removeToken();
  TokenManager.removeRefreshToken();
  UserLocalDataManager.removeUserName();
  OrgMetaManager.removeOrgId();
  OrgMetaManager.removeOrgName();
  localStorage.removeItem(ENFORCEMENT_MODAL_KEY);
  localStorage.removeItem(PASSWORD_ENFORCEMENT_MODAL_KEY);
  sessionStorage.removeItem('orgAccessToken');
  ProductivityFiltersManager.remove();

  const loginMode = LoginModeManager.getLoginMode();

  if (loginMode !== LoginMode.SSO) {
    history.push('/');
  }
};

export const isAuthenticated = () => {
  const orgAccessToken = sessionStorage.getItem('orgAccessToken');
  return !!TokenManager.getToken() || !!orgAccessToken;
};

export const isOrgAdmin = (user: User | undefined | null) => {
  if (isNil(user)) {
    return false;
  }
  return user.type === UserType.OrgAdmin;
};

export const isSsoLoginMode = () => LoginModeManager.getLoginMode() === LoginMode.SSO;

export const isSupportUser = (user: User) => {
  return user.type === UserType.Support;
};

export const logServiceAuthHeader = () => {
  const token = TokenManager.getToken();
  const authObj = {
    Authorization: `Bearer ${token}`,
  };

  return authObj;
};
